<template>
    <div class="col-md-6 p-3">
        <div v-if="paymentIsPendingApprove">
            <strong>{{ trans.get('account.important') }}:</strong>
            {{ trans.get('account.payment_pending_approve') }}
        </div>
        <div v-else-if="paymentIsSuccess">
            <strong>{{ trans.get('account.important') }}:</strong>
            {{ trans.get('account.payment_success') }}
        </div>
        <div v-else-if="paymentFailed">
            <strong>{{ trans.get('account.important') }}:</strong>
            {{ trans.get('account.payment_failed') }}
        </div>
    </div>
</template>
<script>

    import {mapFields} from "vuex-map-fields";

    export default {
        name    : 'message-block',
        props   : {},
        data() {
            return {
            };
        },
        methods : {
        },
        computed: {
            ...mapFields([
                'reference',
                'paymentStatus',
            ]),
            isValid() {
                return true;
            },
            paymentIsPendingApprove() {
                return this.paymentStatus === PAYMENT_PENDING_APPROVAL
            },
            paymentIsSuccess() {
                return this.paymentStatus === PAYMENT_SUCCESS
            },
            paymentFailed() {
                return this.paymentStatus === PAYMENT_FAILED
            },
        }
    }
</script>
